import { useEffect, useState } from 'react';
import { supabase } from './supabaseClient';
import { t } from './i18n';

// Alegerea paginii de Facebook dupa conectare (15 septembrie 2026).
//
// facebook-oauth nu mai leaga nicio pagina: pune lista primita de la Facebook deoparte, pe
// server, iar pagina de intoarcere ne aduce aici cu ?alege_pagina=<id>. Aici omul vede toate
// paginile, fiecare cu contul ei de Instagram, si alege UNA. Paginile legate deja de alt client
// apar blocate, cu numele clientului. Confirmarea se cere si cand e o singura pagina: e ultima
// ocazie de a vedea numele inainte de legare. Planul: PAGINA_PRINCIPALA_PLAN.md.

export function idListaDinAdresa() {
  return new URLSearchParams(window.location.search).get('alege_pagina');
}

export default function AlegePagina() {
  const id = idListaDinAdresa();
  const [stare, setStare] = useState('incarca'); // incarca | alege | salveaza | eroare | expirat
  const [date, setDate] = useState(null);
  const [aleasa, setAleasa] = useState('');
  const [eroare, setEroare] = useState('');

  async function cheama(actiune, extra = {}) {
    const { data, error } = await supabase.functions.invoke('facebook-alege-pagina', {
      body: { actiune, id, ...extra },
    });
    if (error) {
      let corp = null;
      try { corp = await error.context.json(); } catch (e) {}
      return { eroare: (corp && corp.error) || error.message, detaliu: corp && corp.detail };
    }
    return data || {};
  }

  useEffect(() => {
    let activ = true;
    (async () => {
      const r = await cheama('lista');
      if (!activ) return;
      if (r.eroare === 'expirat') { setStare('expirat'); return; }
      if (r.eroare) { setEroare(r.eroare); setStare('eroare'); return; }
      setDate(r);
      // O singura pagina libera: o bifam, dar legarea tot cere click.
      const libere = (r.pagini || []).filter(p => !p.legata_de);
      if (libere.length === 1) setAleasa(libere[0].id);
      setStare('alege');
    })();
    return () => { activ = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function inchide(conectat) {
    window.location.href = conectat && date
      ? `/?facebook=connected&client=${encodeURIComponent(date.client_id)}`
      : '/';
  }

  async function leaga() {
    setStare('salveaza');
    const r = await cheama('alege', { page_id: aleasa });
    if (r.eroare) {
      setEroare(r.eroare === 'legata_de_alt_client'
        ? t('alegePagina', 'legataEroare', { client: r.detaliu || '' })
        : r.eroare);
      setStare('eroare');
      return;
    }
    if (r.avertisment) {
      alert(t('alegePagina', r.avertisment === 'instagram_legat_de_alt_client' ? 'instagramLegatAltClient' : 'instagramNesalvat'));
    }
    inchide(true);
  }

  async function renunta() {
    setStare('salveaza');
    await cheama('renunta');
    inchide(false);
  }

  const butonInapoi = (
    <div className="modal-actiuni">
      <button className="btn-principal" onClick={() => inchide(false)}>{t('alegePagina', 'inapoi')}</button>
    </div>
  );

  return (
    <div className="modal-overlay">
      <div className="modal">
        <div className="modal-header">
          <div className="modal-titlu">
            {date && date.client_nume
              ? t('alegePagina', 'titlu', { client: date.client_nume })
              : t('alegePagina', 'titluScurt')}
          </div>
        </div>

        {stare === 'incarca' && <p style={{ color: '#4B5563' }}>{t('alegePagina', 'seIncarca')}</p>}

        {stare === 'expirat' && (<>
          <p style={{ color: '#4B5563', lineHeight: 1.5 }}>{t('alegePagina', 'expirat')}</p>
          {butonInapoi}
        </>)}

        {stare === 'eroare' && (<>
          <p style={{ color: '#B91C1C', lineHeight: 1.5 }}>{t('alegePagina', 'eroare')} {eroare}</p>
          {butonInapoi}
        </>)}

        {(stare === 'alege' || stare === 'salveaza') && date && (<>
          <p style={{ fontSize: 14, color: '#4B5563', lineHeight: 1.5, marginTop: 0 }}>{t('alegePagina', 'explicatie')}</p>
          <div className="modal-sectiune" style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            {(date.pagini || []).map(p => {
              const blocata = !!p.legata_de;
              const selectata = aleasa === p.id;
              return (
                <label key={p.id} style={{
                  display: 'flex', gap: 12, alignItems: 'flex-start', padding: '12px 14px', borderRadius: 10,
                  border: `1.5px solid ${selectata ? '#1A6B3C' : '#D1E8DA'}`,
                  background: selectata ? '#E8F5EE' : (blocata ? '#F3F4F6' : 'white'),
                  cursor: blocata ? 'not-allowed' : 'pointer',
                }}>
                  <input
                    type="radio" name="pagina-facebook" value={p.id} checked={selectata}
                    disabled={blocata || stare === 'salveaza'} onChange={() => setAleasa(p.id)}
                    style={{ marginTop: 3 }}
                  />
                  <div>
                    <div style={{ fontWeight: 600, color: blocata ? '#4B5563' : '#0F3D22', fontSize: 14 }}>{p.nume}</div>
                    <div style={{ fontSize: 12, color: '#4B5563', marginTop: 2 }}>
                      {p.instagram ? t('alegePagina', 'cuInstagram', { cont: p.instagram }) : t('alegePagina', 'faraInstagram')}
                    </div>
                    {blocata && (
                      <div style={{ fontSize: 12, color: '#92400E', marginTop: 4, fontWeight: 500 }}>
                        {t('alegePagina', 'legataDe', { client: p.legata_de })}
                      </div>
                    )}
                  </div>
                </label>
              );
            })}
          </div>
          <div className="modal-actiuni">
            <button className="btn-principal" disabled={!aleasa || stare === 'salveaza'} onClick={leaga}>
              {stare === 'salveaza' ? t('alegePagina', 'seLeaga') : t('alegePagina', 'leaga')}
            </button>
            <button className="btn-secundar" disabled={stare === 'salveaza'} onClick={renunta}>{t('alegePagina', 'renunta')}</button>
          </div>
        </>)}
      </div>
    </div>
  );
}
